'use strict';

angular.module('ClinicApp').directive('textEditor', function() {
  return {
    restrict: 'A',
    templateUrl: '/views/directives/_text-editor.html',
    scope: {
      title: '=',
      text: '=',
      example: '=',
      textareaPlaceholder: '@',
      textareaStyleClass: '@',
      onSave: '&',
    },
    link: function($scope, el) {
      $scope.text = $scope.text || '';

      // Enable popovers.
      el.find('[data-toggle="popover"]').popover();

      var textarea = el.find('textarea');
      var originalText = $scope.text;

      $scope.enableEditMode = function() {
        $scope.editMode = true;
        setTimeout(function() {
          textarea.focus();
        }, 10);
      };

      $scope.cancel = function() {
        $scope.text = originalText;
        $scope.editMode = false;
      };

      $scope.save = function() {
        return $scope.onSave({
          text: $scope.text,
        }).then(function() {
          originalText = $scope.text;
          $scope.editMode = false;
        });
      };
    },
  };
});
